// extracted by mini-css-extract-plugin
module.exports = {"campaignLabelLink":"CampaignLabelItem_campaignLabelLink__Xgaqz","campaignLabel":"CampaignLabelItem_campaignLabel__xarXA"};